// --------------------------------------------------------------
import Dexie from "dexie";
import store from "@/store";

export let dbs = null;

// 删除指定数据库
const deleteDatabase = async (databaseName) => {
  try {
    await Dexie.delete(databaseName);
    return true; // 返回删除成功的消息
  } catch (error) {
    return false; // 返回删除失败的消息
  }
};

// 数据库统一操作
export const initRevokeDB = async (idbName, KEYS, isDelete = true) => {
  try {
    const name = idbName;
    // 删除已存在的数据库
    isDelete && (await deleteDatabase(name));
    // 创建新的数据库
    dbs = new Dexie(name);
    dbs.version(1).stores(KEYS);
    // 确保数据库已打开
    await dbs.open();
    return "创建成功";
  } catch (error) {
    console.error("数据库初始化失败:", error);
    return "创建失败";
  }
};

//保存撤销数据
export const saveRevokeData = async (obj) => {
  try {
    await dbs.revokeDataCache.put(obj);
    let res = dbs.revokeDataCache.toArray();

    return res[0];
  } catch (error) {
    return false;
  }
};

//保存撤销数据
export const saveStepRevokeData = async (revokeDataStore) => {
  try {
    // 检查数据库是否已关闭
    if (!dbs || !dbs.isOpen()) {
      console.error("数据库未打开或已关闭");
      return false;
    }

    await dbs.revokeDataCache
      .where("id")
      .equals("cacheObj")
      .modify((record) => {
        if (
          !revokeDataStore ||
          ((!revokeDataStore.add || revokeDataStore.add.length === 0) &&
            (!revokeDataStore.delete || revokeDataStore.delete.length === 0) &&
            (!revokeDataStore.edit_before ||
              revokeDataStore.edit_before.length === 0) &&
            (!revokeDataStore.edit_after ||
              revokeDataStore.edit_after.length === 0))
        )
          return;

        if (!record.revokeArr || record.revokeArr.length === 0) {
          record.revokeArr = [];
        }

        let step = record.revokeArr.length;
        if (step >= 10) {
          //将第一步删除
          record.revokeArr.shift();
          step -= 1;
        }

        // Add new step if needed
        if (!record.revokeArr[step]) {
          record.revokeArr.push({
            add: [],
            delete: [],
            edit_before: [],
            edit_after: [],
          });
        }
        // Update the data at current step
        if (revokeDataStore) {
          if (revokeDataStore.add) {
            revokeDataStore.add.forEach((item) => {
              record.revokeArr[step].add.push(item);
            });
          }
          if (revokeDataStore.delete) {
            revokeDataStore.delete.forEach((item) => {
              record.revokeArr[step].delete.push(item);
            });
          }

          if (revokeDataStore.edit_before) {
            revokeDataStore.edit_before.forEach((item) => {
              record.revokeArr[step].edit_before.push(item);
            });
          }

          if (revokeDataStore.edit_after) {
            revokeDataStore.edit_after.forEach((item) => {
              record.revokeArr[step].edit_after.push(item);
            });
          }
        }

        // Update the store with new length
        store.commit("globalData/setRevokeDataLength", step + 1);

        //如果存在回退数据，清空
        if (record.rollbackArr && record.rollbackArr.length) {
          record.rollbackArr = [];
          store.commit("globalData/setRevokeRollbackLength", 0);
        }

        return true;
      });

    // const res = await dbs.revokeDataCache.toArray();
    // return res[0];
  } catch (error) {
    console.log("saveStepRevokeData", error);
    return false;
  }
};

// 频繁单条撤销数据处理
export const saveRevokeDataSingle = async (step, type, obj) => {
  try {
    await dbs.revokeDataCache
      .where("id")
      .equals("cacheObj")
      .modify((record) => {
        let length = record.revokeArr.length;

        //做容错处理，若出现步数比已有数据长度多出很多，修正步数为最大长度
        if (step > length) {
          step = length;
        }

        if (!record.revokeArr[step]) {
          record.revokeArr.push({
            add: [],
            delete: [],
            edit_before: [],
            edit_after: [],
          });
        }

        record.revokeArr[step][type].push(obj);
        store.commit("globalData/setRevokeDataLength", record.revokeArr.length);
      });
  } catch (error) {
    return false;
  }
};

// 频繁单条回退数据处理
export const saveRollbackDataSingle = async () => {
  try {
    await dbs.revokeDataCache
      .where("id")
      .equals("cacheObj")
      .modify((record) => {
        if (!record.rollbackArr || record.rollbackArr.length === 0) {
          record.rollbackArr = [];
        }
        if (record.revokeArr.length <= 1) return;
        record.rollbackArr.push(record.revokeArr[record.revokeArr.length - 1]);
        store.commit(
          "globalData/setRevokeRollbackLength",
          record.rollbackArr.length
        );
      });
  } catch (error) {
    return false;
  }
};

//清空回退数据
export const clearRollbackData = async () => {
  try {
    await dbs.revokeDataCache
      .where("id")
      .equals("cacheObj")
      .modify((record) => {
        record.rollbackArr = [];
        store.commit("globalData/setRevokeRollbackLength", 0);
      });
  } catch (error) {
    return false;
  }
};

// 获取撤销回退数据
export const getRevokeData = async () => {
  try {
    const res = await dbs.revokeDataCache.toArray();
    return res[0];
  } catch (error) {
    return false;
  }
};

//控制撤销步数，删除第一步
export const deleteFirstRevokeData = async () => {
  try {
    await dbs.revokeDataCache
      .where("id")
      .equals("cacheObj")
      .modify((record) => {
        let length = record.revokeArr.length;
        //控制撤销步数
        if (length > 19) {
          record.revokeArr.shift();
          length -= 1;
          store.commit("globalData/setRevokeRollbackLength", length);
        }
        return length;
      });
  } catch (error) {
    return false;
  }
};
